import React, { useEffect, useState } from 'react';
import { Row, Col, message, Spin } from 'antd';

import Bloco from '../../components/Bloco';
import { TransferFilial } from './TransferFilial';
import { ListMigration } from './ListMigration';
import { SubHeader } from './SubHeader';

import * as S from './styles';
import { getControleMigracao } from '../../services/controleMigracao';
import { MigrationProvider } from './context';

export function Migracao() {
  const [dataFiliais, setDataFiliais] = useState([]);
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);
  const [activeMigration, setActiveMigration] = useState(false);
  const [migrationStatus, setMigrationStatus] = useState([]);
  const [gettingTrue, setGettingTrue] = useState([]);

  const initialData = async () => {
    setLoadingReprocessamento(true);

    const { data, error } = await getControleMigracao();

    if (data) {
      setMigrationStatus(data);
      setDataFiliais(data?.filiaisMigracao || []);
      setLoadingReprocessamento(false);
      setActiveMigration(data?.migracaoAtiva);
    }

    if (error) {
      const isError =
        error?.response?.data?.detail || 'Ocorreu um erro indefinido';
      message.error(isError);
      setLoadingReprocessamento(false);
    }

    return setLoadingReprocessamento(false);
  };

  useEffect(() => {
    const separateTrue = {
      autonomo: [],
      propPFDist: [],
      propPFIguais: [],
      propPJDist: [],
      propPJIguais: [],
      arrendDist: [],
      arrendIguais: [],
    };
    if (migrationStatus.edicaoAutonomo === true) {
      separateTrue.autonomo.push('edicaoAutonomo');
    }
    if (migrationStatus.cadastroAutonomo === true) {
      separateTrue.autonomo.push('cadastroAutonomo');
    }
    if (migrationStatus.edicaoPropPFDistintos === true) {
      separateTrue.propPFDist.push('edicaoPropPFDistintos');
    }
    if (migrationStatus.cadastroPropPFDistintos === true) {
      separateTrue.propPFDist.push('cadastroPropPFDistintos');
    }
    if (migrationStatus.edicaoPropPFIguais === true) {
      separateTrue.propPFIguais.push('edicaoPropPFIguais');
    }
    if (migrationStatus.cadastroPropPFIguais === true) {
      separateTrue.propPFIguais.push('cadastroPropPFIguais');
    }
    if (migrationStatus.edicaoPropPJIguais === true) {
      separateTrue.propPJIguais.push('edicaoPropPJIguais');
    }
    if (migrationStatus.cadastroPropPJIguais === true) {
      separateTrue.propPJIguais.push('cadastroPropPJIguais');
    }
    if (migrationStatus.edicaoPropPJDistintos === true) {
      separateTrue.propPJDist.push('edicaoPropPJDistintos');
    }
    if (migrationStatus.cadastroPropPJDistintos === true) {
      separateTrue.propPJDist.push('cadastroPropPJDistintos');
    }
    if (migrationStatus.cadastroArrendatariosDistintos === true) {
      separateTrue.arrendDist.push('cadastroArrendatariosDistintos');
    }
    if (migrationStatus.edicaoArrendatariosDistintos === true) {
      separateTrue.arrendDist.push('edicaoArrendatariosDistintos');
    }
    if (migrationStatus.cadastroArrendatariosIguais === true) {
      separateTrue.arrendIguais.push('cadastroArrendatariosIguais');
    }
    if (migrationStatus.edicaoArrendatariosIguais === true) {
      separateTrue.arrendIguais.push('edicaoArrendatariosIguais');
    }
    setGettingTrue(separateTrue);
  }, [migrationStatus]);

  const init = [];
  dataFiliais.filter(item =>
    //eslint-disable-line
     init.push({
      key: item.idFilial.toString(),
      title: item.nome,
      ativa: item.ativa,
    })
  );

  const initialTargetKeys = init
    .filter(item => item.ativa)
    .map(item => item.key);

  useEffect(() => {
    initialData();
  }, []);

  return (
    <MigrationProvider>
      <Spin
        spinning={loadingReprocessamento}
        size="large"
        style={{
          width: '100%',
        }}
        tip="Carregando dados de Migração"
        delay={200}
      >
        <S.Wrapper>
          <Bloco padding="8px">
            <SubHeader />
          </Bloco>
          <Row
            justify="space-between"
            style={{
              padding: '12px 0 0 0',
            }}
          >
            <Col
              span="9"
              style={{
                paddingRight: 8,
              }}
            >
              <S.CardContent>
                <ListMigration
                  gettingTrue={gettingTrue}
                  migrationStatus={migrationStatus}
                  activeMigration={activeMigration}
                />
              </S.CardContent>
            </Col>
            <Col
              span="15"
              style={{
                paddingLeft: 8,
              }}
            >
              <S.CardContent>
                <TransferFilial
                  data={dataFiliais}
                  init={init}
                  initialTargetKeys={initialTargetKeys}
                  activeMigration={activeMigration}
                />
              </S.CardContent>
            </Col>
          </Row>
        </S.Wrapper>
      </Spin>
    </MigrationProvider>
  );
}
